import React from 'react'

import type { BorrowerInfo } from '../utils/extract-borrower-and-coborrower-from-loans-and-contacts'

type BorrowerNamesCellProps = Readonly<{
	borrowers: {
		borrower?: BorrowerInfo
		coBorrower?: BorrowerInfo
	}
}>

function BorrowerNamesCell({ borrowers }: BorrowerNamesCellProps) {
	const { borrower, coBorrower } = borrowers

	if (!borrower && !coBorrower) return null

	return (
		<div className="flex flex-col min-w-0 gap-1">
			{!!borrower?.name && (
				<p className="truncate">{borrower.name}</p>
			)}
			{!!coBorrower?.name && (
				<p className="truncate">{coBorrower?.name}</p>
			)}
		</div>
	)
}

export default BorrowerNamesCell
